import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M2.35,29.65V1.35h-1v29.3h29.3v-1Z', transform: 'translate(0 0)' }),
  React.createElement('path', {
    d: 'M6.63,26.67a2.71,2.71,0,0,0,2-4.51l3.61-5.26a2.72,2.72,0,0,0,1,.18,2.67,2.67,0,0,0,1.71-.63l2.38,1.79a2.63,2.63,0,0,0-.22,1.05,2.71,2.71,0,1,0,4.5-2l3.69-7.1a2.59,2.59,0,0,0,.63.09,2.72,2.72,0,1,0-2.71-2.71,2.68,2.68,0,0,0,.93,2l-3.69,7.09a2.74,2.74,0,0,0-.64-.08,2.66,2.66,0,0,0-1.7.62l-2.38-1.78a2.82,2.82,0,0,0,.21-1.06,2.71,2.71,0,1,0-4.73,1.8L7.57,21.42a2.66,2.66,0,0,0-.94-.18,2.72,2.72,0,0,0,0,5.43ZM25.9,6.13a1.42,1.42,0,1,1-.64,2.67h0a1.41,1.41,0,0,1,.66-2.66ZM19.79,17.88a1.38,1.38,0,0,1,.64.16h0a1.4,1.4,0,1,1-.66-.17ZM13.21,13a1.41,1.41,0,0,1,1.41,1.41,1.44,1.44,0,0,1-.28.84h0A1.41,1.41,0,1,1,13.21,13ZM6.63,22.54a1.42,1.42,0,1,1-1.019.43,1.42,1.42,0,0,1,1.019-.43Z',
    transform: 'translate(0 0)'
  })
));